import angular from 'angular';

import reportsDataService from 'app/services/data/reports.data.service';
import directive from './download-archived-report.directive';
import controller from './download-archived-report.directive.controller';

export default angular.module('app.components.global.downloadArchivedReport', [
  reportsDataService
])
  .directive('downloadArchivedReport', directive)
  .controller('DownloadArchivedReportDirectiveController', controller)
  .name;

console.log('app.components.global.downloadArchivedReport created');
